export var onReady = function onReady() {
  console.log('onReady');
};